module.exports = __webpack_public_path__ + "img/pen_wht.603ed699.svg";